import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { COLORS } from '../constants/styles';
import OverlayDialog from './OverlayDialog';
import Button from './Button';
import ButtonOutline from './ButtonOutline';
import { TranslationHelpers } from '../../../i18n/translationHelpers';

export interface IConfirmationOverlayProps {
    title: FormattedMessage.MessageDescriptor;
    isOpen: boolean;
    onAccept: () => any;
    onCancel: () => any;
    onClose: () => any;
    confirmButtonText: FormattedMessage.MessageDescriptor;
    children?: ReactNode;
}

const Actions = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;

    & > button:first-child {
        border-color: ${COLORS.rakutenRed};
        color: ${COLORS.rakutenRed};
        margin: 0;
    }

    & > button {
        max-width: 45%;
        width: 200px;
    }
`;

const Content = styled.div`
    padding-top: 20px;
`;

const ConfirmButton = styled(ButtonOutline)``;
const CancelButton = styled(Button)``;

export const ConfirmationOverlay = ({
    title,
    isOpen,
    onCancel,
    onClose,
    onAccept,
    confirmButtonText,
    children,
}: IConfirmationOverlayProps) => {
    return (
        <OverlayDialog title={title} isOpen={isOpen} onClose={onClose}>
            <Content>{children}</Content>
            <Actions>
                <ButtonOutline
                    id="confirm"
                    type="button"
                    text={confirmButtonText}
                    onClick={onAccept}
                    data-qa-id="confirm-action"
                />
                <Button
                    id="cancel"
                    type="button"
                    primary={true}
                    text={TranslationHelpers.getMessageDescriptor('button.cancel')}
                    onClick={onCancel}
                    disabled={false}
                    success={false}
                    data-qa-id="cancel-action"
                />
            </Actions>
        </OverlayDialog>
    );
};
